var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"headline-text-block container-small"},[_c('Headline',{attrs:{"headline":_vm.headline}}),_c('p',{staticClass:"headline-text-block__text"},[_vm._v(_vm._s(_vm.text))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }